import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from './assets/styles/footer.styles'
import logo from './assets/images/logo.svg'
import faceBookLogo from './assets/images/Facebook.svg'
import instagGramLogo from './assets/images/Instagram.svg'
import linkedinLogo from './assets/images/Linkedin.svg'
import twitterLogo from './assets/images/Twitter.svg'
import pinterestLogo from './assets/images/Pinterest.svg'
import youtubeLogo from './assets/images/Youtube.svg'
import { SocialLinks, FooterLinks } from '../configuration'
import { useMediaQuery } from '@material-ui/core'
import BoxDecoration from '../Decorations/Box'
import clsx from 'clsx'

const useStyles = makeStyles(styles)

export default function Footer() {
    const classes = useStyles()
    const isMobile = useMediaQuery('(max-width: 760px)')
    return (
        <div className={classes.root} >
            <BoxDecoration onFooter left='-5%' right='0' top='145%' bottom={0} rotate='22.5deg' scale='1.5' z={4} />
            <BoxDecoration onFooter left='-5%' right='0' top='145%' bottom={0} rotate='45deg' scale='1.5' z={4} />
            <BoxDecoration onFooter left='-5%' right='0' top='145%' bottom={0} rotate='67.5deg' scale='1.5' z={4} />
            <BoxDecoration onFooter left='-5%' right='0' top='145%' bottom={0} rotate='0deg' scale='1.5' z={4} />
            <div className={classes.address} >
                <img className={classes.pageLogo} src={logo} alt='refin logo' />
                {isMobile && SocialMedia(classes)}
                <span className={classes.container} >
                    <p className={clsx(classes.primary, 'strong')} >
                        Ceramiche Refin Spa
                    </p>
                    <p className={classes.secondary} >
                        P.IVA <a className={classes.a} href='tel: 00935330357' >00935330357</a>
                        <br />
                        CF: <a className={classes.a} href='tel: 03047170372' >03047170372</a>
                        <br />
                        Tel. <a className={classes.a} href='tel: +39 0522 990499' >+39 0522 990499</a> 
                    </p>
                </span>
                <span className={classes.container} >
                    <p className={clsx(classes.primary, 'strong')} >
                        Sede Legale
                    </p>
                    <a href={FooterLinks.sedeLegale} className={classes.secondary} >
                        Via I Maggio, 22 Salvaterra
                        <br />
                        42013 Casalgrande (RE) Italy
                    </a>
                </span>
                <span className={classes.container} >
                    <p className={clsx(classes.primary, 'strong')} >
                        Company Showroom
                    </p>
                    <a href={FooterLinks.showroom} className={classes.secondary} >
                        Via G. Ambrosoli, 2 Salvaterra
                        <br />
                        42013 Casalgrande (RE) Italy
                    </a>
                </span>
            </div>
            <div className={classes.copyright} >
                <p className={classes.stamp} >Website © Copyright 2007-2020 Note legali</p>
                {!isMobile && SocialMedia(classes)}
            </div>
        </div>
    )
}

function SocialMedia(classes) {
    return (
        <span className={classes.social}>
            <a target='_blank' rel='noreferrer' className={classes.a} href={`https://${SocialLinks.facebook}`} >
                <img className={classes.socialItems} src={faceBookLogo} alt='facebook' />
            </a>
            <a target='_blank' rel='noreferrer' className={classes.a} href={`https://${SocialLinks.twitter}`} >
                <img className={classes.socialItems} src={twitterLogo} alt='twitter' />
            </a>
            <a target='_blank' rel='noreferrer' className={classes.a} href={`https://${SocialLinks.linkedin}`} >
                <img className={classes.socialItems} src={linkedinLogo} alt='linkedin' />
            </a>
            <a target='_blank' rel='noreferrer' className={classes.a} href={`https://${SocialLinks.instagram}`} >
                <img className={classes.socialItems} src={instagGramLogo} alt='instagram' />
            </a>
            <a target='_blank' rel='noreferrer' className={classes.a} href={`https://${SocialLinks.pinterest}`} >
                <img className={classes.socialItems} src={pinterestLogo} alt='pinterest' />
            </a>
            <a target='_blank' rel='noreferrer' className={classes.a} href={`https://${SocialLinks.youtube}`} >
                <img className={classes.socialItems} src={youtubeLogo} alt='youtube' />
            </a>
        </span>
    )
}